import { useState } from "react";
import Guide1 from "assets/morning/guide1.png";
import Guide2 from "assets/morning/guide2.png";
import Guide3 from "assets/morning/guide3.png";

const OrderGuide = () => {
    const [selected, setSelected] = useState("1");

    const buttons = [
        { label: "당사 픽업접수(회원)", value: "1" },
        { label: "외부 픽업접수(회원)", value: "2" },
        { label: "비회원 픽업접수", value: "3" },
    ];

    return (
        <div className="m-5">
            <div className="w-full max-w-none bg-[#F7F7F8] px-0 flex py-0 rounded-t-xl overflow-hidden">
                {buttons.map(btn => (
                    <button
                        key={btn.value}
                        onClick={() => setSelected(btn.value)}
                        className={`px-4 min-h-[51px] w-full font-semibold text-lg responsive700:text-[14px] responsive700:leading-[18px] ${
                            selected === btn.value
                                ? "bg-white border-t border-x text-new border-new rounded-t-xl"
                                : "bg-[#F7F7F8] text-[#878A93] border-new border-b hover:bg-gray-200 hover:rounded-t-xl "
                        }`}
                    >
                        {btn.label}
                    </button>
                ))}
            </div>
            {selected === "1" ? (
                <img className="mt-5" src={Guide1} alt="Guide 1" />
            ) : selected === "2" ? (
                <img className="mt-5" src={Guide2} alt="Guide 2" />
            ) : (
                <img className="mt-5" src={Guide3} alt="Guide 3" />
            )}
        </div>
    );
};

export default OrderGuide;
